import React from 'react';
import { withInject } from '@piwikpro/platform';
import { ProductBar } from '@piwikpro/ui-components';

// wrapper for ProductBar with proper displayName
// to be able to display StatusBars from Root.TopSection component
// see: https://github.com/PiwikPRO/PPMS-UIComponents/pull/1559#pullrequestreview-984631456
const ProductBarComponent = withInject({
  session: 'AuthCrate.session',
})((props: any) => (
  // eslint-disable-next-line react/destructuring-assignment
  <ProductBar onLogout={() => props.session.logout()}>
    {props.children}
  </ProductBar>
));
ProductBarComponent.displayName = 'ProductBar';

export default ProductBarComponent;
